import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var SizeCache = /*#__PURE__*/function () {
  function SizeCache(_ref) {
    var {
      keyMapper,
      estimatedRowHeight = 0,
      headerHeight = 0,
      footerHeight = 0,
      sectionHeaderHeight = 0,
      sectionFooterHeight = 0
    } = _ref;

    _classCallCheck(this, SizeCache);

    _defineProperty(this, "_keyMapper", void 0);

    _defineProperty(this, "_estimatedRowHeight", void 0);

    _defineProperty(this, "_headerHeight", void 0);

    _defineProperty(this, "_footerHeight", void 0);

    _defineProperty(this, "_sectionHeaderHeight", void 0);

    _defineProperty(this, "_sectionFooterHeight", void 0);

    _defineProperty(this, "_size", void 0);

    this._keyMapper = keyMapper;
    this._estimatedRowHeight = estimatedRowHeight;
    this._headerHeight = headerHeight;
    this._footerHeight = footerHeight;
    this._sectionHeaderHeight = sectionHeaderHeight;
    this._sectionFooterHeight = sectionFooterHeight;
    this._size = {};
  }

  _createClass(SizeCache, [{
    key: "setHeaderHeight",
    value: function setHeaderHeight(headerHeight) {
      this._headerHeight = headerHeight;
    }
  }, {
    key: "getHeaderHeight",
    value: function getHeaderHeight() {
      return this._headerHeight;
    }
  }, {
    key: "setFooterHeight",
    value: function setFooterHeight(footerHeight) {
      this._footerHeight = footerHeight;
    }
  }, {
    key: "getFooterHeight",
    value: function getFooterHeight() {
      return this._footerHeight;
    }
  }, {
    key: "setSectionHeaderHeight",
    value: function setSectionHeaderHeight(sectionHeaderHeight) {
      this._sectionHeaderHeight = sectionHeaderHeight;
    }
  }, {
    key: "getSectionHeaderHeight",
    value: function getSectionHeaderHeight(section) {
      if (typeof this._sectionHeaderHeight === 'function') {
        return this._sectionHeaderHeight(section);
      }

      return this._sectionHeaderHeight;
    }
  }, {
    key: "setSectionFooterHeight",
    value: function setSectionFooterHeight(sectionFooterHeight) {
      this._sectionFooterHeight = sectionFooterHeight;
    }
  }, {
    key: "getSectionFooterHeight",
    value: function getSectionFooterHeight(section) {
      if (typeof this._sectionFooterHeight === 'function') {
        return this._sectionFooterHeight(section);
      }

      return this._sectionFooterHeight;
    }
  }, {
    key: "get",
    value: function get(indexPath) {
      var key = this._keyMapper(indexPath);

      if (key in this._size) {
        return this._size[key];
      }

      if (typeof this._estimatedRowHeight === 'function') {
        return this._estimatedRowHeight(indexPath);
      }

      return this._estimatedRowHeight;
    }
  }, {
    key: "set",
    value: function set(indexPath, size) {
      var key = this._keyMapper(indexPath);

      this._size[key] = size;
    }
  }, {
    key: "setKeyMapper",
    value: function setKeyMapper(keyMapper) {
      this._keyMapper = keyMapper;
    }
  }, {
    key: "setEstimatedRowHeight",
    value: function setEstimatedRowHeight(estimatedRowHeight) {
      this._estimatedRowHeight = estimatedRowHeight;
    }
  }]);

  return SizeCache;
}();

export { SizeCache as default };